module.exports = __webpack_public_path__ + "img/skp.6d29aadf.svg";